
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCashCouponTypeGrid extends Serenity.EntityGrid<PsCashCouponTypeRow, any> {
        protected getColumnsKey() { return PsCashCouponTypeColumns.columnsKey; }
        protected getDialogType() { return PsCashCouponTypeDialog; }
        protected getIdProperty() { return PsCashCouponTypeRow.idProperty; }
        protected getInsertPermission() { return PsCashCouponTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return PsCashCouponTypeRow.localTextPrefix; }
        protected getService() { return PsCashCouponTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this
            });

            return this.slickGrid;
        }
    }
}